import { DataBean } from "../DataBean";


export class DOCFileRecord extends DataBean {

    public async createDOCFileRecord(idEmployee: number, Name: string, Description: string, IDLnTrdRoot: number, classForName: string, IDClass: number): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.DOCFileRecord_createDOCFileRecord_Number_String_String_Number_String_Number", [idEmployee, Name, Description, IDLnTrdRoot, classForName, IDClass]);
    }

    public async getDOCFileRecordRender(page: number, rows: number, props: Record<string, any>): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.shared.Report_getDOCFileRecordRender_Number_Number_java.util.Map", [page, rows, props]);
    }

    public async getDOCFileRecord(iddocfilerecord: number): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.DOCFileRecord_getDOCFileRecord_Number", [iddocfilerecord]);
    }

    public async getDOCFileRecordCatalogPorPropiedades(propiedades: Record<string, any>, maxRows: number): Promise<any> {
        return this.getCustomService("Forms", "java.util.List_getDOCFileRecordCatalogPorPropiedades_java.util.Map_Number", [propiedades, maxRows]);
    }

    public async updateDOCFileRecord(bean: Record<string, any>): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.DOCFileRecord_updateDOCFileRecord_com.advantage.forms.bean.DOCFileRecord", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.advantage.forms.bean.DOCFileRecord"
            }
        ]);
    }

}
